module.exports = __webpack_public_path__ + "img/yellowTwoBallonHorizont.0db3790d.png";